import moment from "moment";
import { entrySummaryStatusMap } from "../../../src/util/constants";

const statementTable = [
  {
    sortVariable: "statementNo",
    labelName: "Statement Number",
    exelExportName: "STATEMENT_NO",
  },
  {
    sortVariable: "importer",
    labelName: "Importer Name",
    exelExportName: "IMPORTER",
  },
  { sortVariable: "PUN", labelName: "Pun", exelExportName: "PUN" },
  {
    sortVariable: "printDate",
    labelName: "Print Date",
    exelExportName: "PRINT_DATE",
  },
  {
    sortVariable: "paymentType",
    labelName: "Payment Type",
    exelExportName: "PAYMENT_TYPE",
  },
  {
    sortVariable: "portOfEntry",
    labelName: "Port Of Entry",
    exelExportName: "PORT_OF_ENTRY",
  },
  {
    sortVariable: "filerCode",
    labelName: "Filer Code",
    exelExportName: "FILER_CODE",
  },
  {
    sortVariable: "amount",
    labelName: "Total Amount",
    exelExportName: "AMOUNT",
  },
];

const dutyDropdownOptions =[
  { description: 'Broker', id: 'Broker' },
  { description: 'Importer', id: 'Importer' },
  { description: 'Individual', id: 'Individual' },
]

const invoiceTable = [
  {
    sortVariable: "invoiceNumber",
    labelName: "Invoice Number",
    exelExportName: "invoiceNumber",
  },
  {
    sortVariable: "importerName",
    labelName: "Importer Name",
    exelExportName: "importerName",
  },
  {
    sortVariable: "createdDate",
    labelName: "Created Date",
    exelExportName: "createdDate",
  },
  {
    sortVariable: "totalCharges",
    labelName: "Total Charges",
    exelExportName: "totalCharges",
  },
  {
    sortVariable: "status",
    labelName: "Status",
    exelExportName: "status",
  },
];

const tableHeader = {
  GB: [
    {
      sortVariable: "mot",
      labelName: "Mot",
      exelExportName: "MOT",
    },
    {
      sortVariable: "shipmentId",
      labelName: "Shipment #",
      exelExportName: "SHIPMENT_ID",
    },
    {
      sortVariable: "importer",
      labelName: "Importer/Exporter",
      exelExportName: "IMPORTER",
    },
    {
      sortVariable: "ducr",
      labelName: "UCN",
      exelExportName: "UCN",
    },
    {
      sortVariable: "entryNumber",
      labelName: "Entry Number",
      exelExportName: "ENTRY_NUMBER",
    },
    {
      sortVariable: "portOfEntry",
      labelName: "Location of Goods",
      exelExportName: "PORT_OF_ENTRY",
    },
    {
      sortVariable: "eta",
      labelName: "ETA",
      exelExportName: "ETA",
    },
    {
      sortVariable: "etd",
      labelName: "ETD",
      exelExportName: "ETD",
    },
    {
      sortVariable: "declarationType",
      labelName: "IM/EX",
      exelExportName: "SHIPMENT_TYPE",
    },
    {
      sortVariable: "carrier",
      labelName: "CARRIER",
      exelExportName: "CARRIER",
    },

    { sortVariable: "status", labelName: "Status", exelExportName: "STATUS" },
  ],

  US: [
    {
      sortVariable: "mot",
      labelName: "Mot",
      exelExportName: "MOT",
    },
    {
      sortVariable: "shipmentId",
      labelName: "Shipment #",
      exelExportName: "SHIPMENT_ID",
    },
    {
      sortVariable: "importer",
      labelName: "Importer/Exporter",
      exelExportName: "IMPORTER",
    },
    {
      sortVariable: "bol",
      labelName: "BOL",
      exelExportName: "BOL",
    },
    { sortVariable: "it", labelName: "IT", exelExportName: "IT" },
    {
      sortVariable: "firmsCode",
      labelName: "FIRMS",
      exelExportName: "FIRMS_CODE",
    },
    {
      sortVariable: "entryNumber",
      labelName: "Entry Number",
      exelExportName: "ENTRY_NUMBER",
    },

    // { sortVariable: "portOfEntry", labelName: "Port of Entry" ,   exelExportName :"PORT_OF_ENTRY" },
    { sortVariable: "eta", labelName: "ETA", exelExportName: "ETA" },
    {
      sortVariable: "releaseDate",
      labelName: "Release Date",
      exelExportName: "RELEASE_DATE",
    },
    {
      sortVariable: "statementDate",
      labelName: "Statement Date",
      exelExportName: "STATEMENT_DATE",
    },
    {
      sortVariable: "dutiesAndTaxes",
      labelName: "Duties & Taxes",
      exelExportName: "DUTIES_AND_TAXES",
    },
    // { sortVariable: "pga", labelName: "PGA", exelExportName :"PGA" },

    // {
    //   sortVariable: "status",
    //   labelName: "Status/Notes",
    //   exelExportName: "STATUS",
    // },
  ],
  CA:[
  ],
  ES:[
  ]
};

const alertRules = {
  US: [
    { key: "ENTRY_NOT_COMPLETED", ruleName: "Entries not completed" },
    // { key: "edr", ruleName: "EDR" },
    // { key: "FDA_HOLD", ruleName: "FDA Hold" },
    // { key: "dis", ruleName: "DIS" },
    { key: "DIS_DOCUMENT_REQUIRED", ruleName: "DIS required" },
    {
      key: "DIS_DOCUMENT_ACCEPTANCE_PENDING",
      ruleName: "DIS acceptance pending",
    },
    // { key: "missingDocs", ruleName: "Missing docs" },
    // { key: "pga", ruleName: "PGA" },
    // { key: "CENSUS_WARNING", ruleName: "Cenus Warnings" },
    // { key: "ADCVD", ruleName: "AD/CVD" },
    { key: "ENTRY_NOT_RELEASED", ruleName: "Entries not Released" },
    // { key: "STATEMENT_WITH_ISSUES", ruleName: "Statements with Issues" },
  ],
  GB: [
    { key: "REJECTS", ruleName: "Rejects" },
    { key: "CLAIM_UCN", ruleName: "Claim UCN" },
    { key: "FAS_TO_BE_DONE", ruleName: "FAS to be done" },
    { key: "HMRC_QUERIES", ruleName: "HMRC Queries" },
    { key: "ROUTE_1", ruleName: "Route 1" },
    { key: "ROUTE_3_STATUS_22", ruleName: "Route 3 Status 22" },
    { key: "PORT_HOLDS", ruleName: "Port Holds" },
    { key: "ROUTE_3", ruleName: "Route 3" },
    { key: "ROUTE_3_E9", ruleName: "Route 3 Status E9" },
    { key: "ROUTE_6_E9", ruleName: "Route 6 Status E9" },
  ],
  CA:[],
  ES:[],
  NL:[]
};

const AlertFilters = {
  GB: [
    "REJECTS",
    "CLAIM_UCN",
    "FAS_TO_BE_DONE",
    "HMRC_QUERIES",
    "ROUTE_1",
    "ROUTE_3_STATUS_22",
    "PORT_HOLDS",
    "ROUTE_3",
    "ROUTE_3_E9",
    "ROUTE_6_E9",
  ],
  US: [
    "ENTRY_NOT_COMPLETED",
    "DIS_DOCUMENT_REQUIRED",
    "DIS_DOCUMENT_ACCEPTANCE_PENDING",
    "ENTRY_NOT_RELEASED",
  ],
  CA:[],
  ES:[],
  NL:[]
};

const QuertyTypeList = {
  GB: [
    "TODAY_ITEMS",
    "THIS_WEEK_ITEMS",
    "THIS_MONTH_ITEMS",
    "THIS_YEAR_ITEMS",
    "RECENT",
    "ACTIVE_SHIPMENTS",
    "REJECT",
    "HOLD",
    "TO_BE_ARRIVED",
    "IMPORT_ARRIVED",
    "OPS_TOTAL",
    "OPS_SPV",
    "OPS_OPS",
    "INVOICES_BILLED",
    "INVOICES_TO_BE_BILLED",
    "TODAY",
    "THIS_WEEK",
    "THIS_MONTH",
    "THIS_YEAR",
    "Hot"
  ],
  US: [
    "INVOICES_BILLED",
    "INVOICES_TO_BE_BILLED",
    "TODAY",
    "THIS_WEEK",
    "THIS_MONTH",
    "THIS_YEAR",
    "Hot",
    "RECENT",
    "ACTIVE_SHIPMENTS",
    "REJECT",
    "HOLD",
    "NOT_BILLED",
    "STATEMENTS_RECEIVED",
    "STATEMENTS_PENDING",
    "STATEMENTS_LATE",
    "PSC_ACTIVE",
    "PSC_STARTED",
    "PSC_NOT_COMPLETED",
    'CENSUS_WARNINGS',
    'PGA_IN_PROCESS'
  ],
  CA :[],
  ES:[],
  NL:[]
};


const GridHeadingList = {
  GB: [
    "Today Lines",
    "This Week Lines",
    "This Month Lines",
    "This Year Lines",
    "Recent",
    "Active",
    "Reject",
    "Hold",
    "To be Arrived",
    "Imports Arrived",
    "Total Ops",
    "Spv",
    "Ops",
    "Billed",
    "To be billed",
    "Today",
    "This Week",
    "This Month",
    "This Year",
    "Hot"
  ],
  US: [
    "Billed",
    "To be billed",
    "Today",
    "This Week",
    "This Month",
    "This Year",
    "Hot",
    "Recent",
    "Active",
    "Reject",
    "Hold",
    "Not Billed",
    "Received",
    "Pending",
    "Late",
    "PSC Active",
    "PSC Started",
    "PSC Not Completed",
    'Census Warning',
    'PGA In Progress'
  ],
  CA:[],
  ES:[],
  NL:[]
};


const klearViewFilters = {
  SEARCH_FILTERS_IMPORTER: "",
  SEARCH_FILTERS_MODE: [
    "MOT_OCEAN",
    "MOT_AIR",
    "MOT_TRUCK",
    "MOT_RAIL",
    "MOT_RAIL_CONTAINER",
    "MOT_MULTIMODAL",
  ],
};

const countBasedOnAlertRules = (key, data) => {
  let count = 0;

  let filteredData = data.filter((item) => {
    return key === item.type;
  });

  count = filteredData.length;
  return count;
};

const formatdate = (possiblydate) => {
  if (
    possiblydate &&
    parseInt(possiblydate) &&
    parseInt(possiblydate) > 1000000000
  ) {
    let newdate = new Date(parseInt(possiblydate));
    possiblydate = `${
      newdate.getUTCMonth() + 1
    }/${newdate.getUTCDate()}/${newdate.getUTCFullYear()}`;
  }
  return possiblydate;
};
const importerCleanup = (name) => {
  if (!name) return "";
  if (name.split("@").length == 2) {
    name = name.split("@")[0];
  }
  return name;
};

const paymentTypeCleanup = (name) => {
  let paymentType = "";
  if (name.includes("IMPORTER_DAILY")) paymentType = "Importer Daily";
  else if (name.includes("IMPORTER_MONTHLY")) paymentType = "Importer Monthly";
  else if (name.includes("BROKER_DAILY")) paymentType = "Broker Daily";
  else if (name.includes("BROKER_MONTHLY")) paymentType = "Broker Monthly";

  return paymentType;
};

export const setMotImageName = (mot) => {
  let imageName = "";
  if (mot === "MOT_OCEAN") imageName = "OCEAN";
  else if ((mot === "MOT_AIR")||(mot === "MOT_AIR_CONTAINER")) imageName = "AIR";
  else if ((mot === "MOT_TRUCK")||(mot === "MOT_MULTIMODAL")) imageName = "TRUCK";
  else if ((mot === "MOT_RAIL")||(mot === "MOT_RAIL_CONTAINER")) imageName = "RAIL";

  return imageName;
};

function dynamicSort(property, isAscDesc) { 
  return function (obj1,obj2) {
      if(isAscDesc==="DESC"){
          return ((obj1[property] > obj2[property]) ? (-1) : ((obj1[property] < obj2[property]) ? (1) : (0)));
      }
      /*else, if isAscDesc==="ASC"*/
      return ((obj1[property] > obj2[property]) ? (1) : ((obj1[property] < obj2[property]) ? (-1) : (0)));
  }
}


const customerDropdownFormatter = (response) => {
  let data = []
  if(response && response.data && response.data.eventMessage && response.data.eventMessage.hasOwnProperty("userGuidFilerCodeMap") === true){
    data = response.data.eventMessage.userGuidFilerCodeMap.map((item, index) => {
      let dropdownItem = {key : ""  , value : "" , text : ""}
      dropdownItem.key = item.key
      dropdownItem.value = item.value
      dropdownItem.text = item.value.toUpperCase()
      return dropdownItem;

    })
  }
  return data;
}
let monthMapping = {
  '01': 'Jan',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Apr',
  '05': 'May',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Aug',
  '09': 'Sep',
  '10': 'Oct',
  '11': 'Nov',
  '12': 'Dec',
}



const formatPrintDateForStatementGrid = (possiblydate) => {
  if(!possiblydate) return ""
  if (possiblydate.length == 6) {
     return  `${monthMapping[possiblydate.substring(0,2)]} ${possiblydate.substring(2,4)}, ${"20".concat(possiblydate.substring(4))}`
  }

};


const prepareShipmentData = (response) => {
  console.log(keyValueMapper()["US"]);
  let data = [];
  data =
    response.data.eventMessage.hasOwnProperty("shipments") === true &&
    response.data.eventMessage.shipments.map((invoiceItem, index) => {
      let newInvoiceItem = keyValueMapper()["US"];
      newInvoiceItem.mot = setMotImageName(invoiceItem.mot) || "";
      newInvoiceItem.shipmentId = invoiceItem.shipmentId || "";
      newInvoiceItem.importer = importerCleanup(invoiceItem.importer) || "";
      newInvoiceItem.bol = invoiceItem.bol || "";
      newInvoiceItem.it = invoiceItem.it !== "_BLANK_" ? invoiceItem.it || "" : "";
      newInvoiceItem.firmsCode = invoiceItem.firmsCode || "";
      newInvoiceItem.entryNumber = invoiceItem.entryNumber || "";
      // newInvoiceItem.portOfEntry = invoiceItem.portOfEntry || "";
      newInvoiceItem.eta = formatdate(invoiceItem.arrivalDate || "");
      newInvoiceItem.releaseDate = invoiceItem.releaseDate || "";
      newInvoiceItem.statementDate = invoiceItem.statementDate || "";
      newInvoiceItem.dutiesAndTaxes = invoiceItem.hasOwnProperty("dutiesAndTaxes") ? "$ ".concat(invoiceItem.dutiesAndTaxes)  :"";
      // newInvoiceItem.pga =  invoiceItem.hasOwnProperty("pga") && invoiceItem.pga  ===  1 ? true : false

      // newInvoiceItem.status = invoiceItem.status || "";
      return newInvoiceItem;
    });

  return data;
};

const prepareStatementGridData = (response) => {
  let data = [];
  data =
    response.data.eventMessage.hasOwnProperty("statements") === true &&
    response.data.eventMessage.statements.map((invoiceItem, index) => {
      let newInvoiceItem = statementkeyValueMapper();
      newInvoiceItem.statementNo = invoiceItem.statementNo || "";
      newInvoiceItem.importer = invoiceItem.importer || "";
      newInvoiceItem.PUN = invoiceItem.PUN || "";
      newInvoiceItem.printDate = formatPrintDateForStatementGrid(invoiceItem.printDate||"")
      newInvoiceItem.paymentType =
        paymentTypeCleanup(invoiceItem.paymentType) || "";
      newInvoiceItem.portOfEntry = invoiceItem.portOfEntry || "";
      newInvoiceItem.filerCode = invoiceItem.filerCode || "";
      newInvoiceItem.amount = invoiceItem.hasOwnProperty("amount") ? "$ ".concat(invoiceItem.amount)  :"";
      return newInvoiceItem;
    });

  return data;
};




const prepareShipmentDataUk = (response, currentShipmentCountry) => {
  console.log(keyValueMapper()["GB"]);
  let data = [];
  data =
    response.data.eventMessage.hasOwnProperty("shipments") === true &&
    response.data.eventMessage.shipments.map((invoiceItem, index) => {
      let newInvoiceItem = keyValueMapper()["GB"];
      newInvoiceItem.mot = setMotImageName(invoiceItem.mot) || "";
      newInvoiceItem.shipmentId = invoiceItem.shipmentId || "";
      newInvoiceItem.importer = importerCleanup(invoiceItem.importer) || "";
      newInvoiceItem.ducr = invoiceItem.ucn || "";
      newInvoiceItem.entryNumber = invoiceItem.entryNumber || "";
      newInvoiceItem.portOfEntry = invoiceItem.portOfEntry || "";
      newInvoiceItem.eta =
        moment.utc(parseInt(invoiceItem.eta)).format("MMM DD YYYY") || "";
      newInvoiceItem.etd =
        moment.utc(parseInt(invoiceItem.etd)).format("MMM DD YYYY") || "";
      newInvoiceItem.declarationType = invoiceItem.shipmentType || "";
      newInvoiceItem.carrier = invoiceItem.carrier || "";
      newInvoiceItem.status =
        entrySummaryStatusMap(invoiceItem.status, currentShipmentCountry)
          .text || "";
      return newInvoiceItem;
    });

  return data;
};

const prepareStatusData = (response) => {
  console.log(keyValueMapper()["US"]);
  let data = [];
  data =
    response.data.eventMessage.hasOwnProperty("shipments") === true &&
    response.data.eventMessage.shipments.map((invoiceItem, index) => {
      console.log("invoice", invoiceItem)
      let newInvoiceItem = {}
      newInvoiceItem.shipmentId = invoiceItem.shipmentId || "";
      newInvoiceItem.ISF = [invoiceItem.isf_ind || "", invoiceItem.isf_status || ""];
      newInvoiceItem.BOL = [invoiceItem.bol_ind || "", invoiceItem.bol_status || ""];
      newInvoiceItem.CR = [invoiceItem.cr_ind || "", invoiceItem.cr_status || ""];
      newInvoiceItem.PGA = [invoiceItem.pga_ind || "", invoiceItem.pga_status || ""];
      newInvoiceItem.ES = [invoiceItem.es_ind || "", invoiceItem.es_status || ""];
      newInvoiceItem.DIS = [invoiceItem.dis_ind || "", invoiceItem.dis_status || ""];
      // newInvoiceItem.pga =  invoiceItem.hasOwnProperty("pga") && invoiceItem.pga  ===  1 ? true : false

      // newInvoiceItem.status = invoiceItem.status || "";
      return newInvoiceItem;
    });

  return data;
}

const keyValueMapper = () => {
  return {
    GB: {
      mot: "",
      shipmentId: "",
      importer: "",
      ducr: "",
      entryNumber: "",
      portOfEntry: "",
      eta: "",
      etd: "",
      declarationType: "",
      carrier: "",
      status: "",
    },

    US: {
      mot: "",
      shipmentId: "",
      importer: "",
      bol: "",
      it: "",
      firmsCode: "",
      entryNumber: "",
      // portOfEntry: "",
      eta: "",
      releaseDate: "",
      statementDate: "",
      dutiesAndTaxes: "",
      // pga : false ,
      // status: "",
    },
    CA:{},
    ES:{}
  };
};

const statementkeyValueMapper = () => {
  return {
    statementNo: "",
    importer: "",
    PUN: "",
    printDate: "",
    paymentType: "",
    portOfEntry: "",
    filerCode: "",
    amount: "",
  };
};

const statementCheckBoxProps = {
  statementNo: true,
  importer: true,
  PUN: true,
  printDate: true,
  paymentType: true,
  portOfEntry: true,
  filerCode: true,
  amount: true,
};

const checkBoxProps = {
  GB: {
    mot: true,
    shipmentId: true,
    importer: true,
    ducr: true,
    entryNumber: true,
    portOfEntry: true,
    eta: true,
    etd: true,
    declarationType: true,
    carrier: true,
    status: true,
  },
  US: {
    mot: true,
    shipmentId: true,
    importer: true,
    bol: true,
    it: true,
    firmsCode: true,
    entryNumber: true,
    // portOfEntry: true,
    eta: true,
    releaseDate: true,
    statementDate: true,
    dutiesAndTaxes: true,
    // pga : true ,
    status: true,
  },
  CA:{},
  ES:{}
};


const pms =[{"payementType": "PAYMENT_STATEMENT_CODE_BROKER_DAILY","dutiesAndTaxes": [{"month": "JUNE","noOfEntries": "23"},{"month": "JUNE","noOfEntries": "23"},{"month": "JUNE","noOfEntries": "23"}]},
{"payementType": "PAYMENT_STATEMENT_CODE_BROKER_MONTHLY","dutiesAndTaxes": [{"month": "082321","noOfEntries": "23"},{"month": "082321","noOfEntries": "23"},{"month": "082321","noOfEntries": "23"}]}]
export {
  tableHeader,
  alertRules,
  statementTable,
  QuertyTypeList,
  GridHeadingList,
  invoiceTable,
  klearViewFilters,
  dutyDropdownOptions,
  prepareStatementGridData,
  statementCheckBoxProps,
  pms,
  countBasedOnAlertRules,
  checkBoxProps,
  prepareShipmentData,
  prepareShipmentDataUk,
  prepareStatusData,
  AlertFilters,
  dynamicSort,
  customerDropdownFormatter,
};
